import { render, staticRenderFns } from "./PerformanceTargetsTabOverview.vue?vue&type=template&id=8839ba46"
import script from "./PerformanceTargetsTabOverview.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetsTabOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports